import React, { useState } from 'react';
import { Button } from './ui/button';
import { Bus, X } from 'lucide-react';
import TransportationInterestModal from './TransportationInterestModal';

const FloatingCTA = () => {
  const [showModal, setShowModal] = useState(false);
  const [isMinimized, setIsMinimized] = useState(false);

  if (isMinimized) {
    return (
      <button
        onClick={() => setIsMinimized(false)}
        className="fixed bottom-6 right-6 z-40 w-16 h-16 rounded-full bg-gradient-to-r from-[#0077BE] to-[#00B4D8] text-white shadow-2xl hover:shadow-3xl transition-all duration-300 hover:scale-110 flex items-center justify-center group"
        aria-label="Request Transportation"
      >
        <Bus className="w-7 h-7 group-hover:scale-110 transition-transform" />
      </button>
    );
  }

  return (
    <>
      <div className="fixed bottom-6 right-6 z-40 flex items-center gap-3 animate-fade-in">
        <Button
          onClick={() => setShowModal(true)}
          className="bg-gradient-to-r from-[#0077BE] to-[#00B4D8] text-white shadow-2xl hover:shadow-3xl px-6 py-6 rounded-2xl text-lg font-semibold transition-all duration-300 hover:scale-105 flex items-center gap-3"
        >
          <Bus className="w-6 h-6" />
          <span className="hidden sm:inline">Request Transportation</span>
          <span className="sm:hidden">Get Service</span>
        </Button>
        
        <button
          onClick={() => setIsMinimized(true)}
          className="w-10 h-10 rounded-full bg-white shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105 flex items-center justify-center text-gray-600 hover:text-gray-900"
          aria-label="Minimize"
        >
          <X className="w-5 h-5" />
        </button>
      </div>

      <TransportationInterestModal 
        open={showModal} 
        onOpenChange={setShowModal}
      />
    </>
  );
};

export default FloatingCTA;
